/*
 * @Description:
 * @Date: 2020-07-19 10:36:03
 */

let modules = {};
const storeContext = require.context('./', true, /\.js$/);
storeContext.keys().forEach(modulesItem => {
  if (!modulesItem.includes('index')) {
    modules[modulesItem.replace(/(^\.\/)|(\.js$)/g, '')] = storeContext(
      modulesItem
    ).default;
  }
});
export default modules;
